export const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8200');
export const BUILD_ID = "v1.31-005e777";
